import Cookies from "universal-cookie";
import jstz from "jstz";
import moment from "moment-timezone";

const cookies = new Cookies();

export class CookieUtil {

    /**
     * Save a value to cookies
     * @param name - Cookie name
     * @param value - Value to save (object or string)
     * @param options - Cookie options (e.g., path, expiry, etc.)
     */
    static saveCookie(name: string, value: any): void {
        let cookie = [name, '=', JSON.stringify(value), '; domain=.', window.location.host.toString(), '; path=/;'].join('');
        document.cookie = cookie;
    }


    /**
     * Read a value from cookies
     * @param name - Cookie name
     * @returns Parsed cookie value or null if not found
     */
    static readCookie<T>(name: string): T | null {
        try{
            let result:any = document.cookie.match(new RegExp(name + '=([^;]+)'));
            let resp =  result && (result = result[1]);
            return resp;
        } catch (error) {
            console.log("error======4444====>readCookie=", error);
            return null;
        }
    }

   

    static deleteCookie(name: string): void {
        document.cookie = name +'=; Path=/; Expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }


    static getCookie<T = unknown>(name: string = "user_info"): T | null {
        const result = document.cookie.match(new RegExp(`${name}=([^;]+)`));
    
        const isJsonString = (str: string): boolean => {
            try {
                JSON.parse(str);
                return true;
            } catch {
                return false;
            }
        };
    
        if (
            result &&
            result[1] !== "undefined" &&
            result[1] !== undefined &&
            result[1] !== `${name}=undefined,undefined` &&
            result[1] !== `${name}=undefined`
        ) {
            const value = isJsonString(result[1]) ? JSON.parse(result[1]) : result[1];
            return value as T;
        }
    
        return null;
    }

    static setCookie(cname:string, cvalue:string): void {
        try {
            let d = new Date();
            d.setTime(d.getTime() + (60 * 24 * 60 * 60 * 1000));
            let expires = "expires="+ d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        } catch (error) {
            console.log("Error in set cookies: ",error)
        }
       
    }
    static getToken(): any {
        let userInfo:any = this.readCookie('a_token');
        if(userInfo) {
            return userInfo
        }
        return null;
    }
}
export default CookieUtil;
